import EditorJs from '@editorjs/editorjs';
import uuid from 'uuid';
import { InstructionCSSClasses, InstructionEvent } from '../../components/script-editor/tools/types';
import { EditorData } from './types';
import { findInstructionElement } from '../../components/script-editor/tools/utils';

export default class DuplicateInstruction {
  constructor(private editor:EditorJs, private notifHandler: ()=>void, private setValueToEditor: Function, private instructionId: string, private scriptData: EditorData) {

  }

  duplicateBlock() {
    const blockIndex = this.scriptData.blocks.findIndex((item) => item.data.instructionId === this.instructionId);
    const newBlock = { ...this.scriptData.blocks[blockIndex] };
    if (newBlock) {
      const existInstruction = this.scriptData.instructions.find((instruction) => instruction.id === this.instructionId);
      if (existInstruction) {
        const newInstruction = { ...existInstruction, id: uuid() };
        newBlock.data.instructionId = newInstruction.id;
        this.editor.blocks.insert(
          newBlock.type,
          newBlock.data,
          undefined,
          blockIndex + 1,
        );
        this.editor.emit(InstructionEvent.ADD_INSTRUCTIONS_TO_DATA, [newInstruction]);
        this.editor.emit(InstructionEvent.SUBMIT_DATA, {});
        this.notifHandler();
      }
    }
  }

  duplicateInline() {
    const selector = InstructionCSSClasses.INLINE_INSTRUCTION_CONTENT;
    const foundInstruction = this.scriptData.instructions.find((item) => item.id === this.instructionId);
    const element = findInstructionElement({ instructionId: this.instructionId, isInline: true });

    if (element && foundInstruction) {
      const newInstruction = { ...foundInstruction, id: uuid() };
      this.scriptData.instructions.push(newInstruction);
      const range = new Range();
      const contentElement = element.querySelector(`.${selector}`);
      if (contentElement) {
        const duplicatedInstruction = contentElement.parentElement;
        if (duplicatedInstruction) {
          range.selectNode(duplicatedInstruction);
          const clone = range.cloneContents();
          const cloneElement = clone.querySelector('.inline-instruction-wrapper');
          if (cloneElement) {
            cloneElement.setAttribute('instruction-id', newInstruction.id);
          }
          range.setStartAfter(duplicatedInstruction);
          range.insertNode(clone);
          duplicatedInstruction.after(' ');
        }
      }
      this.setValueToEditor('script', JSON.stringify(this.scriptData));
      this.editor.events.emit(InstructionEvent.SUBMIT_DATA, {});
      this.editor.emit(InstructionEvent.UPDATE_INLINE_ACTION_EVENT_LISTENERS, {});
      this.notifHandler();
    }
  }
}
